import React, { useEffect, useMemo, useRef, useState } from 'react';
// import compassImg from './laban-400px.png';
import rCompassImg from './compass-ruler.png';
// import compassArrowImg from './arrow-laban.png';
import RotationHandler from './RotationHandler';
import RulerArrow from './ruler-arrow.svg';

import './style.scss';
import { COMPASS_DEGREE_SCENE_DATA } from 'consts/hardcoded-data';

const radiansToDegrees = (radians) => {
  return Math.round(radians * (180 / Math.PI));
};

const DEFAULT_RULER_PARAM = 0.9013888888888889;

const RullerCompass = ({ deg }) => {
  const compassRef = useRef(null);

  const RulerTranslation = useMemo(() => {
    return -deg * DEFAULT_RULER_PARAM;
  }, [deg]);

  useEffect(() => {
    compassRef.current.style.transform = `translateX(${
      RulerTranslation || 0
    }px)`;
  }, [RulerTranslation]);

  return (
    <div className="Rcompass-container">
      <img
        className="Rcompass-container--ruler-arrow"
        src={RulerArrow}
        alt="ruller-arrow"
      />
      <div className="Rcompass-container--wrapper" ref={compassRef}>
        <div
          className="Rcompass-container--img"
          style={{ backgroundImage: `url(${rCompassImg})` }}
        ></div>
      </div>
    </div>
  );
};



const CompassContainer = ({
  currentPano,
  cameraParams,
  sceneRotation,
  ...props
}) => {
  const [rotationY, setRotationY] = useState(0);
  const isVisible = useMemo(() => {
    if (currentPano?._id && COMPASS_DEGREE_SCENE_DATA[currentPano?._id] !== undefined) {
      return true;
    }
    return false;
  }, [currentPano]);

  const defaultDegree = useMemo(() => {
    if (currentPano?._id && COMPASS_DEGREE_SCENE_DATA[currentPano?._id]) {
      return COMPASS_DEGREE_SCENE_DATA[currentPano?._id];
    }
    return 0;
  }, [currentPano]);

  const compassDeg =
    useMemo(() => radiansToDegrees(rotationY), [rotationY]) || 0;

  if (!isVisible) return null;

  return (
    <>
      {currentPano && (
        <RotationHandler
          cameraParams={cameraParams}
          sceneRotation={sceneRotation}
          setRotationY={setRotationY}
          currentPano={currentPano}
        />
      )}
      {/* <Compass {...props} deg={compassDeg + defaultDegree} /> */}
      <RullerCompass {...props} deg={compassDeg + defaultDegree} />
    </>
  );
};

export default CompassContainer;
